<!--
    描述：资源订阅入口页面
    时间：2020-06-16
    Created by yefan
-->
<template>
	<transition name="fade"
				mode="out-in">
		<router-view></router-view>
	</transition>
</template>

<script>
export default {
	name: 'Resource-management',
	data() {
		return {}
	},
	methods: {}
}
</script>

<style scoped lang="less">
</style>

